// Lightweight cookie/consent banner for GDPR / Google EU User Consent Policy.
// Stores the visitor's choice in localStorage. For full EEA/UK compliance with
// personalized advertising, also enable AdSense's built-in "Privacy & Messaging"
// in the AdSense dashboard — this banner is the site's own first-party notice.

const STORAGE_KEY = "ac-cookie-consent";

function getChoice() {
    try {
        return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
        return null;
    }
}

function setChoice(value) {
    try {
        localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
        // ignore (private mode etc.)
    }
}

export function initConsentBanner() {
    if (getChoice() !== null) return;

    var banner = document.createElement("div");
    banner.className = "consent-banner";
    banner.setAttribute("role", "dialog");
    banner.setAttribute("aria-label", "Cookie consent");

    var text = document.createElement("p");
    text.innerHTML = `We use cookies to operate this site, remember your preferences, and serve personalized ads via Google AdSense. See our <a href="/privacy">Privacy Policy</a> for details.`;
    banner.appendChild(text);

    var actions = document.createElement("div");
    actions.className = "consent-actions";

    var reject = document.createElement("button");
    reject.className = "consent-btn consent-btn-reject";
    reject.textContent = "Reject";
    reject.addEventListener("click", function () {
        setChoice("rejected");
        dismiss(banner);
    });

    var accept = document.createElement("button");
    accept.className = "consent-btn consent-btn-accept";
    accept.textContent = "Accept";
    accept.addEventListener("click", function () {
        setChoice("accepted");
        dismiss(banner);
    });

    actions.appendChild(reject);
    actions.appendChild(accept);
    banner.appendChild(actions);

    document.body.appendChild(banner);

    // Auto-dismiss after 30s if the user ignores it (still no explicit choice).
    setTimeout(function () {
        if (getChoice() === null && document.body.contains(banner)) {
            dismiss(banner);
        }
    }, 30000);
}

function dismiss(banner) {
    if (!banner || !banner.parentNode) return;
    banner.parentNode.removeChild(banner);
}

export default { initConsentBanner };
